import { Box } from '@mui/material';
import { Rule } from 'api/ml-service/ml-service.types';
import { useTranslation } from 'react-i18next';
import CustomRuleDetailsList from './custom-rule-details-list/custom-rule-details-list.component';

type CustomRuleDetailsProps = {
  rule: Rule;
};

const CustomRuleDetails = ({ rule }: CustomRuleDetailsProps) => {
  const { t } = useTranslation();
  let selectedProductsTitle, selectedProductsList;

  if (rule.triggerMenus.length > 0) {
    selectedProductsTitle = t(
      'page.menus.recommendations.customRules.savedCustomRules.moreDetails.selectedProducts.menus.title',
    );
    selectedProductsList = rule.triggerMenus;
  } else if (rule.triggerGroups.length > 0) {
    selectedProductsTitle = t(
      'page.menus.recommendations.customRules.savedCustomRules.moreDetails.selectedProducts.groups.title',
    );
    selectedProductsList = rule.triggerGroups;
  } else {
    selectedProductsTitle = t(
      'page.menus.recommendations.customRules.savedCustomRules.moreDetails.selectedProducts.items.title',
    );
    selectedProductsList = rule.triggerItems;
  }

  return (
    <Box display="grid" gridTemplateColumns="1fr 1fr" width="100%" gap={4}>
      <CustomRuleDetailsList
        list={selectedProductsList}
        title={selectedProductsTitle}
        testIdSuffix="SelectedProduct"
      />
      <CustomRuleDetailsList
        list={rule.recommendationItems}
        title={t(
          'page.menus.recommendations.customRules.savedCustomRules.moreDetails.recommendations.title',
        )}
        testIdSuffix="RecommendedItems"
      />
    </Box>
  );
};

export default CustomRuleDetails;
